import PracticeDictation from "./practice-dictation";
import PracticeFilling from "./practice-filling";
import PracticeMathFilling from "./practice-math-filling";
import PracticeQuiz from "./practice-quiz";
import PracticeGrammarDragAndDrop from "./practice-grammar-drag-and-drop";
import { Question, QuestionType } from "@/constant/schema";
import PracticeHighlight from "./practice-highlight";

interface PracticeCardProps {
  question: Question;
  handleAnswer: (option: string, isCorrect: boolean, autoSubmit?: boolean) => void;
  currentAnswer: any;
  allFinished: boolean;
  disabled: boolean;
  onInputChange?: (value: string) => void;
  triggerCheck?: boolean;
  isChatActive?: boolean;
}

const PracticeCard = ({
  question,
  handleAnswer,
  currentAnswer,
  allFinished,
  disabled,
  onInputChange,
  triggerCheck,
  isChatActive = false,
}: PracticeCardProps) => {
  console.log(question);
  if (question?.type === QuestionType.MATH_BLANK_FILLING) {
    return (
      <PracticeMathFilling key={question.id} question={question} handleAnswer={handleAnswer} currentAnswer={currentAnswer} allFinished={allFinished} disabled={disabled} onInputChange={onInputChange} triggerCheck={triggerCheck}  needButtons={false} />
    )
  }
  if (question?.type === QuestionType.DICTATION) {
    return (
      <PracticeDictation key={question.id} question={question} handleAnswer={handleAnswer} currentAnswer={currentAnswer} disabled={disabled} onInputChange={onInputChange} triggerCheck={triggerCheck} />
    )
  }
  if (question?.type === QuestionType.MULTIPLE_CHOICE || question?.type === QuestionType.GRAMMAR_CLASSIFICATION) {
    return (
      <PracticeQuiz
        question={question}
        handleAnswer={handleAnswer}
        currentAnswer={currentAnswer}
        allFinished={allFinished}
        disabled={disabled}
        isChatActive={isChatActive}
      />
    )
  }
  if (question?.type === QuestionType.BLANK_FILLING || question?.type === QuestionType.GRAMMAR_FILL_IN_BLANK) {
    return (
      <PracticeFilling question={question} handleAnswer={handleAnswer} currentAnswer={currentAnswer} allFinished={allFinished} disabled={disabled} className="w-full max-w-[800px] mx-auto flex flex-col items-center justify-center" onInputChange={onInputChange} triggerCheck={triggerCheck} needButtons={false} />
    )
  }
  if (question?.type === QuestionType.HIGHLIGHT) {
    return (
      <PracticeHighlight question={question} handleAnswer={handleAnswer} currentAnswer={currentAnswer} allFinished={allFinished} disabled={disabled} onInputChange={onInputChange} triggerCheck={triggerCheck} />
    )
  }
  if (question?.type === QuestionType.GRAMMAR_DRAG_AND_DROP) {
    return (
      <PracticeGrammarDragAndDrop question={question} handleAnswer={handleAnswer} currentAnswer={currentAnswer} disabled={disabled} onInputChange={onInputChange} triggerCheck={triggerCheck} />
    )
  }
  return (
    <div />
  )
}

export default PracticeCard;
